






import { Component, Vue, Inject, Watch } from 'vue-property-decorator';
import { ApiService } from '../services/api.service';
import { Response, Survey } from '../models';
import * as SurveyVue from 'survey-vue';
import { of as observableOf, Subject } from 'rxjs';
import { finalize, takeUntil, catchError } from 'rxjs/operators';
import { validateCode, timestamp } from '../utils/expression';

@Component({
  components: {}
})
export default class Home extends Vue {
  @Inject('$api') private api!: ApiService;
  unsubscribe$: Subject<void> = new Subject<void>();
  loading = false;
  item: Survey | null = null;
  survey: SurveyVue.SurveyModel | null = null;

  created() {
    this.findById();
  }

  destoryed() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  @Watch('$route')
  routeChanged(newVal: any, oldVal: any) {
    if (newVal && newVal !== oldVal) {
      this.findById();
    }
  }

  private bindSurvey(survey: string) {
    SurveyVue.FunctionFactory.Instance.register(
      'validateCode',
      validateCode,
      true
    );
    SurveyVue.FunctionFactory.Instance.register('timestamp', timestamp, false);
    SurveyVue.StylesManager.applyTheme('modern');
    this.survey = (window as any)['survey'] = new SurveyVue.Model(survey);

    this.survey.onComplete.add(result => {
      const response = new Response({
        surveyId: this.item!.id,
        result: result.getPlainData({ includeQuestionTypes: true })
      });
      this.api.createAsync('response', response).subscribe();
    });
  }

  private async findById() {
    this.loading = true;
    await this.api
      .getAsync<Survey>(`survey/${this.$route.params.id}`)
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => (this.loading = false)),
        catchError(() => {
          this.loading = false;
          return observableOf(new Survey({ isActive: false }));
        })
      )
      .subscribe(data => {
        if (data.isActive) {
          this.item = new Survey(data);
          this.bindSurvey(this.item.definition);
        } else {
          this.$router.push('/404');
        }
      });
  }
}
